export const administrationFeeMarginsConstants = {
    GET_ADMINISTRATION_FEE_MARGINS_REQUEST: 'GET_ADMINISTRATION_FEE_MARGINS_REQUEST',
    GET_ADMINISTRATION_FEE_MARGINS_SUCCESS: 'GET_ADMINISTRATION_FEE_MARGINS_SUCCESS',
    GET_ADMINISTRATION_FEE_MARGINS_ERROR: 'GET_ADMINISTRATION_FEE_MARGINS_ERROR',

    PUT_ADMINISTRATION_FEE_MARGINS_REQUEST: 'PUT_ADMINISTRATION_FEE_MARGINS_REQUEST',
    PUT_ADMINISTRATION_FEE_MARGINS_SUCCESS: 'PUT_ADMINISTRATION_FEE_MARGINS_SUCCESS',
    PUT_ADMINISTRATION_FEE_MARGINS_ERROR: 'PUT_ADMINISTRATION_FEE_MARGINS_ERROR'
};
